import { travelGuideQueryKeys as e } from "./travelGuideQueryKeys.mjs";
import { useInfiniteListQuery as t, useMutation as n, useQuery as r, useQueryClient as i } from "@maat/store-hooks";
import { adminTravelGuidesApi as a } from "@maat/api-main";
//#region src/travelGuides/useAdminGuideModeration.ts
var o = (n) => t({
	queryKey: e.moderation(n),
	fetchPage: (e) => a.listModeration({
		...n,
		page: e
	}),
	key: "guides"
}), s = (t) => r({
	queryKey: e.moderationDetail(t),
	queryFn: () => a.getModeration(t),
	enabled: !!t
}), c = (t, n) => {
	t.invalidateQueries({ queryKey: ["travelGuides", "moderation"] }), t.invalidateQueries({ queryKey: e.moderationDetail(n) });
}, l = () => {
	let e = i();
	return n({
		mutationFn: ({ guideId: e, reason: t }) => a.approve(e, t),
		onSuccess: (t, { guideId: n }) => c(e, n)
	});
}, u = () => {
	let e = i();
	return n({
		mutationFn: ({ guideId: e, reason: t }) => a.reject(e, t),
		onSuccess: (t, { guideId: n }) => c(e, n)
	});
}, d = () => {
	let e = i();
	return n({
		mutationFn: (e) => a.reRun(e),
		onSuccess: (t, n) => c(e, n)
	});
}, f = () => n({ mutationFn: (e) => a.draftFeedback(e) });
//#endregion
export { s as useAdminGuideModerationDetailQuery, o as useAdminGuideModerationQuery, l as useApproveGuideMutation, f as useDraftGuideFeedbackMutation, d as useReRunGuideModerationMutation, u as useRejectGuideMutation };
